import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.column}>
          <h3 className={styles.heading}>Information</h3>
          <ul>
            <li>
              <a
                href="https://www.tennisshop.ae/about-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="https://www.tennisshop.ae/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="https://www.tennisshop.ae/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
            </li>
            <li>
              <a
                href="https://www.tennisshop.ae/blog/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Blog
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.column}>
          <h3 className={styles.heading}>Customer Service</h3>
          <ul>
            <li>
              <a
                href="https://www.tennisshop.ae/shipping-returns/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Shipping & Returns
              </a>
            </li>
            <li>
              <a
                href="https://www.tennisshop.ae/contact-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="https://www.tennisshop.ae/faqs"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help & FAQs
              </a>
            </li>
            <li>
              <a
                href="https://www.tennisshop.ae/find-a-store/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Store Locations
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.bottomRow}>
        <div className={styles.copyRight}>
          © 2025 TennisShop.Ae. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;